// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Assistant: microphone button (bottom inline-start, clear of the page FAB at inline-end) and
   its sheet. Colours only from design-system tokens. */

.assistant-fab {
  position: fixed;
  z-index: 950;
  inset-inline-start: calc(var(--ds-space-4) + var(--ds-safe-left));
  bottom: calc(var(--ds-space-4) + var(--ds-safe-bottom));
  width: 56px;
  height: 56px;
  border: 0;
  border-radius: var(--ds-radius-pill);
  background: var(--ds-chrome-bg);
  color: var(--ds-chrome-text-strong);
  box-shadow: var(--ds-shadow-lg);
  font-size: 22px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: transform 0.15s var(--ds-ease), background 0.15s var(--ds-ease);
}

.assistant-fab:hover {
  background: var(--ds-chrome-bg-deep);
}

.assistant-fab:focus-visible {
  outline: none;
  box-shadow: var(--ds-focus-ring), var(--ds-shadow-lg);
}

.assistant-fab:active {
  transform: scale(0.94);
}

.assistant-fab--live {
  background: var(--ds-danger);
  animation: assistant-pulse 1.4s ease-in-out infinite;
}

.app-shell--with-bottomnav .assistant-fab {
  bottom: calc(var(--ds-bottomnav-h) + var(--ds-safe-bottom) + var(--ds-space-4));
}

/* On wide screens the sider sits at inline-start: keep the button inside the content area */
@media (min-width: 992px) {
  .assistant-fab {
    inset-inline-start: calc(var(--ds-sider-w) + var(--ds-space-4));
  }
}

@keyframes assistant-pulse {
  0%,
  100% {
    box-shadow: 0 0 0 0 var(--ds-danger-bg), var(--ds-shadow-lg);
  }
  50% {
    box-shadow: 0 0 0 10px var(--ds-danger-bg), var(--ds-shadow-lg);
  }
}

.assistant-sheet .ant-drawer-content {
  background: var(--ds-surface);
}

.assistant-sheet.ant-drawer-bottom .ant-drawer-content {
  border-start-start-radius: var(--ds-radius-xl);
  border-start-end-radius: var(--ds-radius-xl);
}

.assistant-quota {
  font-size: 12px;
  font-weight: normal;
}

.assistant-log {
  flex: 1;
  overflow-y: auto;
  padding: var(--ds-space-4);
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-3);
}

.assistant-empty .ant-btn {
  white-space: normal;
  height: auto;
  text-align: start;
}

.assistant-msg {
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-2);
  max-width: 92%;
}

.assistant-msg--user {
  align-self: flex-end;
  align-items: flex-end;
}

.assistant-msg--assistant {
  align-self: flex-start;
}

.assistant-bubble {
  padding: var(--ds-space-2) var(--ds-space-3);
  border-radius: var(--ds-radius-lg);
  background: var(--ds-surface-muted);
  color: var(--ds-text);
  white-space: pre-wrap;
  overflow-wrap: anywhere;
}

.assistant-msg--user .assistant-bubble {
  background: var(--ds-brand-50);
  color: var(--ds-brand-ink);
}

.assistant-bubble--error {
  background: var(--ds-danger-bg);
  color: var(--ds-danger);
}

.assistant-card {
  border: 1px solid var(--ds-border);
  border-inline-start: 4px solid var(--ds-warning);
  border-radius: var(--ds-radius-md);
  padding: var(--ds-space-3);
  background: var(--ds-surface);
  box-shadow: var(--ds-shadow-xs);
  display: flex;
  flex-direction: column;
  gap: var(--ds-space-1);
}

.assistant-card--executed {
  border-inline-start-color: var(--ds-success);
}

.assistant-card--dismissed,
.assistant-card--failed {
  border-inline-start-color: var(--ds-border);
  opacity: 0.85;
}

.assistant-card--conflict {
  border-inline-start-color: var(--ds-danger);
}

.assistant-card__label {
  font-weight: 600;
  color: var(--ds-heading);
}

.assistant-card__detail {
  color: var(--ds-text-2);
  font-size: 13px;
}

.assistant-card__warning {
  background: var(--ds-warning-bg);
  border-radius: var(--ds-radius-sm);
  padding: var(--ds-space-2);
  font-size: 13px;
}

.assistant-card__buttons {
  margin-top: var(--ds-space-2);
}

.assistant-card__buttons .ant-btn {
  min-height: 40px;
}

.assistant-input {
  border-top: 1px solid var(--ds-border-soft);
  padding: var(--ds-space-3) var(--ds-space-4) calc(var(--ds-space-3) + var(--ds-safe-bottom));
  background: var(--ds-surface);
}

.assistant-input__row {
  display: flex;
  align-items: flex-end;
  gap: var(--ds-space-2);
}

.assistant-interim {
  color: var(--ds-text-muted);
  font-size: 13px;
  margin-bottom: var(--ds-space-2);
}

.assistant-rec-dot {
  display: inline-block;
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background: var(--ds-danger);
  margin-inline-end: 6px;
  animation: assistant-blink 1s steps(2, start) infinite;
}

@keyframes assistant-blink {
  to {
    visibility: hidden;
  }
}

@media (prefers-reduced-motion: reduce) {
  .assistant-fab--live,
  .assistant-rec-dot {
    animation: none;
  }
}
`, "",{"version":3,"sources":["webpack://./src/serviceProvider/components/assistant/Assistant.css"],"names":[],"mappings":"AAAA;uDACuD;;AAEvD;EACE,eAAe;EACf,YAAY;EACZ,iEAAiE;EACjE,uDAAuD;EACvD,WAAW;EACX,YAAY;EACZ,SAAS;EACT,oCAAoC;EACpC,+BAA+B;EAC/B,mCAAmC;EACnC,+BAA+B;EAC/B,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,2EAA2E;AAC7E;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,aAAa;EACb,qDAAqD;AACvD;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,4BAA4B;EAC5B,oDAAoD;AACtD;;AAEA;EACE,+EAA+E;AACjF;;AAEA,4FAA4F;AAC5F;EACE;IACE,+DAA+D;EACjE;AACF;;AAEA;EACE;;IAEE,4DAA4D;EAC9D;EACA;IACE,+DAA+D;EACjE;AACF;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,8CAA8C;EAC9C,4CAA4C;AAC9C;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,OAAO;EACP,gBAAgB;EAChB,0BAA0B;EAC1B,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,oBAAoB;EACpB,qBAAqB;AACvB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,4CAA4C;EAC5C,kCAAkC;EAClC,mCAAmC;EACnC,qBAAqB;EACrB,qBAAqB;EACrB,uBAAuB;AACzB;;AAEA;EACE,8BAA8B;EAC9B,0BAA0B;AAC5B;;AAEA;EACE,+BAA+B;EAC/B,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,gDAAgD;EAChD,kCAAkC;EAClC,0BAA0B;EAC1B,6BAA6B;EAC7B,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;;EAEE,2CAA2C;EAC3C,aAAa;AACf;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,uBAAuB;EACvB,eAAe;AACjB;;AAEA;EACE,gCAAgC;EAChC,kCAAkC;EAClC,0BAA0B;EAC1B,eAAe;AACjB;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,2CAA2C;EAC3C,4FAA4F;EAC5F,6BAA6B;AAC/B;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA;EACE,2BAA2B;EAC3B,eAAe;EACf,gCAAgC;AAClC;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,WAAW;EACX,kBAAkB;EAClB,4BAA4B;EAC5B,sBAAsB;EACtB,sDAAsD;AACxD;;AAEA;EACE;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE;;IAEE,eAAe;EACjB;AACF","sourcesContent":["/* Assistant: microphone button (bottom inline-start, clear of the page FAB at inline-end) and\n   its sheet. Colours only from design-system tokens. */\n\n.assistant-fab {\n  position: fixed;\n  z-index: 950;\n  inset-inline-start: calc(var(--ds-space-4) + var(--ds-safe-left));\n  bottom: calc(var(--ds-space-4) + var(--ds-safe-bottom));\n  width: 56px;\n  height: 56px;\n  border: 0;\n  border-radius: var(--ds-radius-pill);\n  background: var(--ds-chrome-bg);\n  color: var(--ds-chrome-text-strong);\n  box-shadow: var(--ds-shadow-lg);\n  font-size: 22px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: transform 0.15s var(--ds-ease), background 0.15s var(--ds-ease);\n}\n\n.assistant-fab:hover {\n  background: var(--ds-chrome-bg-deep);\n}\n\n.assistant-fab:focus-visible {\n  outline: none;\n  box-shadow: var(--ds-focus-ring), var(--ds-shadow-lg);\n}\n\n.assistant-fab:active {\n  transform: scale(0.94);\n}\n\n.assistant-fab--live {\n  background: var(--ds-danger);\n  animation: assistant-pulse 1.4s ease-in-out infinite;\n}\n\n.app-shell--with-bottomnav .assistant-fab {\n  bottom: calc(var(--ds-bottomnav-h) + var(--ds-safe-bottom) + var(--ds-space-4));\n}\n\n/* On wide screens the sider sits at inline-start: keep the button inside the content area */\n@media (min-width: 992px) {\n  .assistant-fab {\n    inset-inline-start: calc(var(--ds-sider-w) + var(--ds-space-4));\n  }\n}\n\n@keyframes assistant-pulse {\n  0%,\n  100% {\n    box-shadow: 0 0 0 0 var(--ds-danger-bg), var(--ds-shadow-lg);\n  }\n  50% {\n    box-shadow: 0 0 0 10px var(--ds-danger-bg), var(--ds-shadow-lg);\n  }\n}\n\n.assistant-sheet .ant-drawer-content {\n  background: var(--ds-surface);\n}\n\n.assistant-sheet.ant-drawer-bottom .ant-drawer-content {\n  border-start-start-radius: var(--ds-radius-xl);\n  border-start-end-radius: var(--ds-radius-xl);\n}\n\n.assistant-quota {\n  font-size: 12px;\n  font-weight: normal;\n}\n\n.assistant-log {\n  flex: 1;\n  overflow-y: auto;\n  padding: var(--ds-space-4);\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-3);\n}\n\n.assistant-empty .ant-btn {\n  white-space: normal;\n  height: auto;\n  text-align: start;\n}\n\n.assistant-msg {\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-2);\n  max-width: 92%;\n}\n\n.assistant-msg--user {\n  align-self: flex-end;\n  align-items: flex-end;\n}\n\n.assistant-msg--assistant {\n  align-self: flex-start;\n}\n\n.assistant-bubble {\n  padding: var(--ds-space-2) var(--ds-space-3);\n  border-radius: var(--ds-radius-lg);\n  background: var(--ds-surface-muted);\n  color: var(--ds-text);\n  white-space: pre-wrap;\n  overflow-wrap: anywhere;\n}\n\n.assistant-msg--user .assistant-bubble {\n  background: var(--ds-brand-50);\n  color: var(--ds-brand-ink);\n}\n\n.assistant-bubble--error {\n  background: var(--ds-danger-bg);\n  color: var(--ds-danger);\n}\n\n.assistant-card {\n  border: 1px solid var(--ds-border);\n  border-inline-start: 4px solid var(--ds-warning);\n  border-radius: var(--ds-radius-md);\n  padding: var(--ds-space-3);\n  background: var(--ds-surface);\n  box-shadow: var(--ds-shadow-xs);\n  display: flex;\n  flex-direction: column;\n  gap: var(--ds-space-1);\n}\n\n.assistant-card--executed {\n  border-inline-start-color: var(--ds-success);\n}\n\n.assistant-card--dismissed,\n.assistant-card--failed {\n  border-inline-start-color: var(--ds-border);\n  opacity: 0.85;\n}\n\n.assistant-card--conflict {\n  border-inline-start-color: var(--ds-danger);\n}\n\n.assistant-card__label {\n  font-weight: 600;\n  color: var(--ds-heading);\n}\n\n.assistant-card__detail {\n  color: var(--ds-text-2);\n  font-size: 13px;\n}\n\n.assistant-card__warning {\n  background: var(--ds-warning-bg);\n  border-radius: var(--ds-radius-sm);\n  padding: var(--ds-space-2);\n  font-size: 13px;\n}\n\n.assistant-card__buttons {\n  margin-top: var(--ds-space-2);\n}\n\n.assistant-card__buttons .ant-btn {\n  min-height: 40px;\n}\n\n.assistant-input {\n  border-top: 1px solid var(--ds-border-soft);\n  padding: var(--ds-space-3) var(--ds-space-4) calc(var(--ds-space-3) + var(--ds-safe-bottom));\n  background: var(--ds-surface);\n}\n\n.assistant-input__row {\n  display: flex;\n  align-items: flex-end;\n  gap: var(--ds-space-2);\n}\n\n.assistant-interim {\n  color: var(--ds-text-muted);\n  font-size: 13px;\n  margin-bottom: var(--ds-space-2);\n}\n\n.assistant-rec-dot {\n  display: inline-block;\n  width: 8px;\n  height: 8px;\n  border-radius: 50%;\n  background: var(--ds-danger);\n  margin-inline-end: 6px;\n  animation: assistant-blink 1s steps(2, start) infinite;\n}\n\n@keyframes assistant-blink {\n  to {\n    visibility: hidden;\n  }\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .assistant-fab--live,\n  .assistant-rec-dot {\n    animation: none;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
